<template>
  <v-select
    v-model="localValue"
    :items="localTypes"
    item-text="name"
    item-value="id"
    hide-no-data
    :label="$t('labels.blockerType')"
    required
    :error-messages="errors"
    :menu-props="{ maxWidth: '316px', closeOnContentClick: true }"
  />
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { CustomFieldMixin } from '@argon/app/mixins'
import { NAMESPACE } from '../store'

export default {
  name: 'BlockerTypeField',
  mixins: [CustomFieldMixin],
  props: {
    provided: Array
  },
  methods: {
    ...mapActions(NAMESPACE, ['listTypes'])
  },
  computed: {
    ...mapState(NAMESPACE, ['types']),
    localTypes() {
      return this.provided || this.types
    }
  },
  created() {
    let getTypes = !this.provided && this.types.length === 0
    if (getTypes) {
      this.listTypes().catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .v-list__tile {
  height: 72px !important;
  align-items: top !important;
}

.v-list__tile__sub-title {
  white-space: normal !important;
}
</style>
